import z from "zod";
import { ZodDateString } from "../../zod-types/zod-date-string";

export const getCrewDefinitionAbsenceDaysQuerySchema = z.object({
	startDate: ZodDateString,
	endDate: ZodDateString,
});

export type GetCrewDefinitionAbsenceDaysQuerySchema = z.infer<
	typeof getCrewDefinitionAbsenceDaysQuerySchema
>;
